import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { API_URL } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';

const UserProfile = () => {
  const token = getToken();
  const [user, setUser] = useState([]);
  const userType = decodeToken(token, 'userType');
  const isEnabled2FA = decodeToken(token, 'isEnabled2FA');
  const userLevel = decodeToken(token, 'userLevel');

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        // API call to login
        const response = await axios.get(
          `${API_URL}/api/users/profile/${userType}-profile`,
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          }
        );

        console.log(response.data.company);
        setUser(response.data.user[0]);
      } catch (error) {
        // Handle error (e.g., invalid credentials)
        console.log('erro:', error);
        // setError('Company not found');
      }
    };

    fetchProfile();
  }, [token]);

  return (
    <div className="container mt-5">
      <div className="row">
        {/* Profile Header */}
        <div className="col-md-4 text-center">
          <img
            src={`${API_URL}/${user.image}`}
            alt="Profile"
            className="rounded-circle img-fluid"
            style={{ width: '150px', height: '150px', objectFit: 'cover' }}
          />
          <h3 className="mt-3">{user.name}</h3>
          <p className="text-muted">{user.email}</p>
          {isEnabled2FA && (
            <a href="/register-2fa" className="btn btn-danger">
              Enable 2FA
            </a>
          )}
        </div>

        {/* User Details */}
        <div className="col-md-8">
          <h4 className="mb-3">User Details</h4>
          <ul className="list-group">
            <li className="list-group-item">
              <strong>Name:</strong> {user.name}
            </li>
            <li className="list-group-item">
              <strong>Email:</strong> {user.email}
            </li>
            <li className="list-group-item">
              <strong>Username:</strong> {user.user_name}
            </li>
            {/* <li className="list-group-item">
              <strong>Gender:</strong> {user.gender}
            </li> */}
            <li className="list-group-item">
              <strong>Status:</strong> {user.status}
            </li>
            <li className="list-group-item">
              <strong>Joined:</strong> {user.date}
            </li>
            <li className="list-group-item">
              <strong>Last Activity:</strong> {user.modified_date}
            </li>
            <li className="list-group-item">
              <a href={`${API_URL}/uploads/my-app.apk`}>Download App</a>
            </li>
            {userLevel === 'developer' && (
              <>
                <li className="list-group-item">
                  <strong>Token:</strong> {token}
                </li>
                <li className="list-group-item">
                  <strong>Device Token:</strong>{' '}
                  {localStorage.getItem('trusted_device')}
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
